module.exports = __webpack_public_path__ + "static/media/icon-lightbulb.fba93a8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-lightbulb.svg
// module id = 889
// module chunks = 0